import { Prompt } from "@/types/app/prompt";
import { PageSectionHeader } from "@components/library/PageSectionHeader";
import { ChatMessages } from "@components/llama/ChatMessages";
import { DescriptionDetailsTruncated, DescriptionTerm } from "@components/llama/DescriptionList";
import { None } from "@components/llama/Tables/Logs/LogCells";
import { formatPromptTemplateHTML } from "@components/PromptEditor/FormattedPrompt";
import { Tag } from "@phosphor-icons/react";
import ScrollToBottom from "react-scroll-to-bottom";

type TemplateDetailsProps = Pick<Prompt, "template" | "template_language">;

export const TemplateDetails = (props: TemplateDetailsProps) => {
  const jinjaTag = props.template_language === "jinja" ? <Tag>{props.template_language}</Tag> : null;

  if (typeof props.template === "string") {
    return (
      <div className="">
        <PageSectionHeader title="Template" size="sm" actionsTray={jinjaTag} />

        <div className="-ml-4">
          <DescriptionDetailsTruncated lines={10}>
            {formatPromptTemplateHTML(props.template || "")}
          </DescriptionDetailsTruncated>
        </div>
      </div>
    );
  }
  if (Array.isArray(props.template)) {
    return (
      <>
        <PageSectionHeader title="Template" size="sm" actionsTray={jinjaTag} />

        {props.template?.length ? (
          <ChatMessages
            messages={props.template}
            highlightVariables
            templateLanguage={props?.template_language || "default"}
          />
        ) : (
          <DescriptionTerm>
            <None />
          </DescriptionTerm>
        )}
      </>
    );
  }
  return null;
};
